import { type FC, useEffect, useState } from 'react';
import { getClockOffset, isClockOffsetSignificant } from '../utils/clock';

/**
 * Displays a warning banner when the device clock is significantly
 * out of sync with the server. This can prevent live data from displaying.
 */
export const ClockOffsetWarning: FC = () => {
  const [offsetSeconds, setOffsetSeconds] = useState<number | null>(null);

  useEffect(() => {
    if (isClockOffsetSignificant()) {
      setOffsetSeconds(Math.round(getClockOffset() / 1000));
    }
  }, []);

  if (offsetSeconds == null) return null;

  const absSeconds = Math.abs(offsetSeconds);
  const direction = offsetSeconds > 0 ? 'behind' : 'ahead';
  const minutes = Math.floor(absSeconds / 60);
  const seconds = absSeconds % 60;
  const formattedOffset =
    minutes > 0 ? `${minutes} min${seconds > 0 ? ` ${seconds} sec` : ''}` : `${absSeconds} sec`;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 10000,
        backgroundColor: '#ff9800',
        color: '#000',
        padding: '8px 16px',
        textAlign: 'center',
        fontSize: '14px',
        fontWeight: 500,
        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
      }}
    >
      ⚠️ Your device clock is {formattedOffset} {direction}. Live tracking data may not display
      correctly. Please correct your system time.
    </div>
  );
};
